import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { useOrders } from '~/hooks/orders';

import Dashboard from '~/layouts/Dashboard';
import POS from '../POS';

const OrdersTable: React.FC = () => {
  const history = useHistory();
  const { orderTables, loadOrdersTable } = useOrders();

  const [openPos, setOpenPos] = useState(false);
  const [ordem, setOrdem] = useState<string>('Último Pedido');

  const orderd = useMemo(() => {
    if (ordem === 'Número da Mesa') {
      return orderTables.sort((a, b) =>
        a.table_name > b.table_name? 1 : b.table_name > a.table_name? -1 : 0,
      );
    }

    return orderTables.sort((a, b) =>
      a.updated_at > b.updated_at ? -1 : b.updated_at > a.updated_at ? 1 : 0,
    );
  }, [orderTables, ordem]);

  useEffect(() => {
    loadOrdersTable();
  }, [loadOrdersTable]);

  const handleClick = useCallback(
    (uid: string) => {
      history.push(`/table-orders/${uid}`);
    },
    [history],
  );

  return (
    <Dashboard containerMessage="col-xl-12">
      <div className="col-xl-12">
        <div className="nk-block-head nk-block-head-sm">
          <div className="nk-block-between">
            <div className="nk-block-head-content d-flex justify-between">
              <h3 className="nk-block-title page-title">Pedidos de Mesa</h3>
            </div>

            <div className="d-flex align-center">
              <p className="mb-0 mr-2">
                <strong>Ordernar Por:</strong>
              </p>
              <div className="drodown">
                <Link
                  to="#status"
                  className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                  data-toggle="dropdown"
                >
                  {ordem}
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                  <ul className="link-list-opt no-bdr">
                    <li>
                      <Link
                        to="#last-order"
                        onClick={() => {
                          setOrdem('Último Pedido');
                        }}
                      >
                        <span>Último Pedido</span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#table-number"
                        onClick={() => {
                          setOrdem('Número da Mesa');
                        }}
                      >
                        <span>Número da Mesa</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="row">
          {orderd.map((item, index) => (
            <div
              key={index}
              className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-3"
            >
              <div
                className="card card-bordered"
                style={{ cursor: 'pointer' }}
                onClick={() => handleClick(item.id)}
              >
                <div className="card-inner" style={{background: item.alert && !item.waiter_name ? '#fceae9' : 'white'}}>
                  <div className="d-flex justify-content-between">
                    <p>
                      <strong>Mesa</strong>
                      <br />
                      <strong>Aberta: {item.created_at_formatted}</strong>
                      <br />
                      <strong>Último pedido: {item.updated_at_formatted}</strong>
                    </p>
                    <strong>{item.total_formmated}</strong>
                  </div>
                  {/* <div className="d-flex justify-content-end">
                    <p className='text-right'>
                      
                    </p>
                  </div> */}
                  <div className="d-flex justify-content-between align-items-end">
                    <h1 className="mb-0">{item.table_name}</h1>
                    <strong className="mb-0">{item.waiter_name}</strong>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={() => setOpenPos(true)}
        style={{
          width: 42,
          height: 42,
          borderRadius: '50%',
          background: '#000',
          color: '#fff',
          position: 'fixed',
          bottom: 10,
          right: 10,
          zIndex: 9,
        }}
      >
        <em className="icon ni ni-plus" />
      </button>

      {openPos && (
        <>
          <POS />
          <button
            onClick={() => setOpenPos(false)}
            type="button"
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              zIndex: 999999,
              width: 38,
              height: 38,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <em className="icon fa fa-times" />
          </button>
        </>
      )}
    </Dashboard>
  );
};

export default OrdersTable;
